import { render } from "./SeaViewIcon.vue?vue&type=template&id=08a2987f"
import script from "./SeaViewIcon.vue?vue&type=script&lang=js"
export * from "./SeaViewIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__